import { useMeContext } from '../api/me-provider.js';
import { ThemeToggle } from '../components/theme-toggle.js';

/**
 * The athlete's Account (Athlete Portal canvas, "Noa · Account", approved 16
 * October): who they are, their username and the theme. The line on a forgotten
 * password was cut 18 October (Matthew). Nothing they can change about the
 * account: the parent looks after it.
 */
export function AthleteAccountRoute() {
  const { state } = useMeContext();
  if (state.status !== 'athlete') return null;
  const { athlete } = state;

  return (
    <>
      <div className="page-head">
        <div>
          <h2>
            {athlete.first_name} {athlete.last_name}
          </h2>
          <span className="detail">Born {athlete.birth_year}</span>
        </div>
      </div>

      <div className="fact">
        <span className="label">Username</span>
        <span className="value">{athlete.username}</span>
      </div>

      <span className="section-label">Theme</span>
      <ThemeToggle />
    </>
  );
}
